import React from "react";
import { ContinueButton, ModalTemplate, SoundFx } from "@deliverr/ui-facility";
import { FormattedMessage } from "react-intl";
import { useSortationModal } from "sortation/components/SortationModal";
import { sortationDangerIconProps } from "sortation/components/SortationModal/sortationModalIconProps";
import { OutboundModal } from "./OutboundModal";

export interface OutboundErrorModalProps {
  title: string;
  text: string;
  hideModalValue: OutboundModal;
}

export const OutboundErrorModal: React.FC<OutboundErrorModalProps> = ({ title, text, hideModalValue }) => {
  const { hideModal } = useSortationModal();
  return (
    <ModalTemplate
      title={<FormattedMessage id="sortation.scanGaylord.errorModalTitle" defaultMessage={title} />}
      text={<FormattedMessage id="sortation.scanGaylord.errorModalText" defaultMessage={text} />}
      iconProps={sortationDangerIconProps}
      soundFx={SoundFx.ERROR_FAST}
    >
      <ContinueButton block onClick={() => hideModal(hideModalValue)} />
    </ModalTemplate>
  );
};
